import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Emitter from './Emitter';

export default class Rocket extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene);

    this.flame = ABCyaPhaser.Images.addImage(60,500, UIAssetKeys._flames, this).setOrigin(0);
    this.flame.alpha = 0;
    this.flame.angle = -20;

    this.rocket = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._rocket2, this).setOrigin(0);

    this.catInWindow = ABCyaPhaser.Images.addImage(145, 198, UIAssetKeys._cat_in_window, this).setOrigin(0);
    this.catInWindow.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.catInWindow, 200, { delay: 2900, alpha: 1, onStart: () => this.liftOff() }, Phaser.Math.Easing.Linear);
  }

  liftOff () {
    const flameLoop = () => {
      ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 0.8 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 1.2 }, Phaser.Math.Easing.Linear, () => {
          flameLoop();
        });
      });
    };
    flameLoop();

    ABCyaPhaser.Tweens.addTween(this.flame, 10, { delay: 1600, alpha: 1 }, Phaser.Math.Easing.Linear, () => {
      this.makeSmoke(750,550);
      this.scene.time.delayedCall(5000, () => this.emitter.destroy());
    });

    let loopsRemaining = 8;
    const xPos = this.x;
    const thisLoop = () => {
      if (this.scene === null || this.scene === undefined) {
        return;
      }
      const duration = 50;
      ABCyaPhaser.Tweens.addTween(this, duration, { x: xPos - 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
        if (this.scene === null || this.scene === undefined) {
          return;
        }
        ABCyaPhaser.Tweens.addTween(this, duration, { x: xPos + 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
          if (this.scene === null || this.scene === undefined) {
            return;
          }
          loopsRemaining--;
          if (loopsRemaining > 0) {
            thisLoop();
          }
        });
      });
    };
    thisLoop();
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.tweens.killTweensOf([this, this.flame]));

    ABCyaPhaser.Tweens.addTween(this, 4000, { delay: 1600, y: this.y - 1000 }, Phaser.Math.Easing.Linear);
  }

  makeSmoke (x, y) {
    this.emitter = new Emitter(this.scene);
    this.emitter.x = x;
    this.emitter.y = y;

    this.add(this.emitter);
    this.emitter.emitSmoke();
  }
}